import React, { useEffect, useRef, useState } from 'react'
import './teams-list.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartPie, faMagnifyingGlass, faMagnifyingGlassArrowRight, faPen, faPlus } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '@/components/SHARED/search-bar/search-bar.component';
import { stripHtml } from '@/utils/sanitize';
import { useNavigate } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { useSelector } from 'react-redux';

const TeamsList = ({ 
    playerList,
    teamList }) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ showFilterModal, setShowFilterModal ] = useState(false);
    const [ contentToDisplay, setContentToDisplay ] = useState([]);
    const [ selectedCategories, setSelectedCategories ] = useState([]);
    const catRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        catRef.current = [];
    }, [])

    useEffect(() => {
        if (!teamList) return;
        console.log(teamList);
        setContentToDisplay([]);
        // console.log(teamList);
        setContentToDisplay(Object.values(teamList).filter(a => a.team))
    }, [teamList])

    function search(e) {
        if (!e) {
            setContentToDisplay(Object.values(teamList))
            return;
        }
        setContentToDisplay(
            Object.values(teamList)
            .filter(a => 
                a.name.toLowerCase().includes(e) || 
                (a.desc && a.desc.toLowerCase().includes(e))
            )
        )
    }
    
    return (
        <div className={`teams-list ${screenSize}`}>
            <div className='teams-list-search'>
                <SearchBar search={search} />
                <button 
                    type='button' 
                    className='g-button med-btn' 
                    onClick={() => navigate('create')}>
                    {
                        screenSize !== 'mobile'
                        ?
                        <span>Create a New Team</span>
                        :
                        "Create"
                    }
                    <FontAwesomeIcon icon={faPlus} />
                </button>
            </div>
            <div className="g-space-1"></div>
            <div className='teams-list-div'>
                <div className='g-list-item teams-list-head row'>
                    <div></div>
                    <div>Name</div>
                    {
                        (screenSize !== 'mobile') &&
                        <div>Description</div>
                    }
                    <div className='center'>
                        # of Members
                    </div>
                    <div></div>
                </div>
                <div className='g-space-0-5'></div>
                <div className='teams-list'>
                    {
                        (contentToDisplay.length > 0)
                        ?
                        contentToDisplay.sort((a,b) => a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1)
                        .map(c => (
                            <div 
                                key={c.playerId} 
                                className='g-list-item row'>
                                <div className='teams-icon-div'>
                                    <ImageContainer 
                                        src={c.icon} 
                                        alt={`${c.displayName} teams icon`} 
                                        className='teams-icon'
                                        preview={true} />
                                </div>
                                <div className='teams-name'>
                                    {c.displayName}
                                </div>
                                {
                                    (screenSize !== 'mobile') &&
                                    <div className='teams-desc meta'>
                                        {
                                            c.desc && 
                                            stripHtml(c.desc).substring(0,60)
                                        }
                                        {
                                            c.desc && 
                                            stripHtml(c.desc).length > 60 
                                            ? '...' 
                                            : ''
                                        }
                                    </div>
}
                                <div className='meta center'>
                                    {
                                        c.opt_activeMemberCount 
                                        ? c.opt_activeMemberCount
                                        : 0
                                    }
                                </div>
                                <div className='buttons'>    
                                    {/* <button className='g-button med-btn' title='View team data'><FontAwesomeIcon icon={faChartPie} /></button> */}
                                    <button 
                                        className='g-button med-btn' 
                                        onClick={() => navigate(c.path)} 
                                        title='Edit this team'>
                                        <FontAwesomeIcon icon={faMagnifyingGlass} />
                                    </button>
                                </div>
                            </div>
                        ))
                        :
                        <p>No Teams yet...</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default TeamsList